import type { Action } from 'kbar'
import type { Channel } from '../../common/types'
import type { ChannelActionOverrides } from './useGlobalContextActions'

function goToChannel(channel: Channel, url: string): void {
  const [, ...domain] = window.location.hostname.split('.')
  let newUrl: string
  if (channel.service === 'startPage') {
    newUrl = `https://start-page.${domain.join('.')}/${channel.id}/${url}`
  } else {
    newUrl = `https://publish.${domain.join('.')}/profile/${channel.id}/${url}`
  }
  return window.location.assign(newUrl)
}

export function selectChannel(channel: Channel): void {
  goToChannel(channel, '')
}

const START_PAGE_ACTIONS = [
  {
    name: 'Appearance',
    path: 'appearance',
  },
  {
    name: 'Layout',
    path: 'layout',
  },
  {
    name: 'Statistics',
    path: 'statistics',
  },
  {
    name: 'Settings',
    path: 'settings',
  },
]

const DEFAULT_ACTIONS = [
  {
    name: 'Queue',
    path: '?tab=queue',
  },
  {
    name: 'Sent',
    path: '?tab=sent',
  },
  {
    name: 'Approvals',
    path: '?tab=approvals',
  },
  {
    name: 'Drafts',
    path: '?tab=drafts',
  },
  {
    name: 'Settings',
    path: '/settings',
  },
]

const toChannelAction = ({
  channel,
  name,
  path,
  channelActionOverrides,
  navigateToChannel,
}: {
  channel: Channel
  name: string
  path: string
  channelActionOverrides: ChannelActionOverrides
  navigateToChannel: (channel: Channel, tabPath?: string) => void
}): Action => ({
  id: `channel-${channel.id}-${path}`,
  parent: `channel-${channel.id}`,
  name,
  perform: (): void => {
    if (channelActionOverrides[path]) {
      channelActionOverrides[path]({ channel })
    } else {
      navigateToChannel(channel, path)
    }
  },
})

export function makeChannelActions(
  channel: Channel,
  channelActionOverrides: ChannelActionOverrides,
  navigateToChannel: (channel: Channel, tabPath?: string) => void,
): Action[] {
  const actionList =
    channel.service === 'startPage' ? START_PAGE_ACTIONS : DEFAULT_ACTIONS
  return actionList.map(({ name, path }) =>
    toChannelAction({
      channel,
      name,
      path,
      channelActionOverrides,
      navigateToChannel,
    }),
  )
}
